import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import Select from "../../components/Select/Select";
import { selectAction } from "../../redux/rootReducer";
import { SELECT_INITIAL } from "../../redux/initialStateConstant";
import { GetSlugsThunk } from "../../redux/thunks/GetSlugsThunk";
import { UpdateSlugThunk } from "../../redux/thunks/UpdateSlagThunk";

const Slugs = () => {
    const dispatch = useDispatch();
    const slugs = useSelector(state => state.slugs);
    const user = useSelector(state => state.user);

    const currentSlug = useMemo(() => {
        if (!slugs.length || !user?.slug) return '';
        const found = slugs.find(el => el.id === user.slug);
        return found ? found.name : '';
    }, [slugs, user?.slug]);

    useEffect(() => {
        dispatch(GetSlugsThunk());
    }, [dispatch]);

    return (
        <>
            <Header/>
            <div className="page">
                <div className="page__content">
                    {
                        !slugs.length
                        ?
                            <div className="table__caption">Нет записей</div>
                        :
                            <div className="form__field" style={{ maxWidth: '320px' }}>
                                <div className="input__caption">Поиск заведения</div>
                                <Select
                                    current={ currentSlug }
                                    type={ 'slug' }
                                    options={ slugs }
                                    handler={ elem => {
                                        dispatch(selectAction(SELECT_INITIAL));
                                        dispatch(UpdateSlugThunk({ slug: elem.id }));
                                    } }
                                    smart={ true }
                                />
                            </div>
                    }
                </div>
            </div>
        </>
    );
};

export default Slugs;